import { defineComponent as _defineComponent } from 'vue'
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { defineAsyncComponent } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'WidgetHelp',
  props: {
    widget: null,
    position: { default: 'is-bottom-right' }
  },
  setup(__props: any) {



function openCloseAll() {
  document.body
    .querySelectorAll('details')
    .forEach((e) =>
      e.hasAttribute('open')
        ? e.removeAttribute('open')
        : e.setAttribute('open', 'true'),
    );
}

function onDropdownTriggerClicked() {
  document.body
    .querySelectorAll('details')
    .forEach((e) => (e.hasAttribute('open') ? e.removeAttribute('open') : ''));
}

const componentHelp: Record<WidgetEnum, any> = {
  /* WCC */
  // Cut
  [WidgetEnum.LaserAvailability]: defineAsyncComponent(
    () => import('./widgetHelp/LaserAvailabilityHelp.vue'),
  ),
  [WidgetEnum.LaserAvailabilityHist]: defineAsyncComponent(
    () => import('./widgetHelp/LaserAvailabilityHistHelp.vue'),
  ),
  [WidgetEnum.LaserProductivity]: defineAsyncComponent(
    () => import('./widgetHelp/LaserProductivityHelp.vue'),
  ),
  [WidgetEnum.LaserProductivityHist]: defineAsyncComponent(
    () => import('./widgetHelp/LaserProductivityHistHelp.vue'),
  ),
  [WidgetEnum.LaserStarveBlock]: defineAsyncComponent(
    () => import('./widgetHelp/LaserStarveBlockHelp.vue'),
  ),
  [WidgetEnum.LaserOutputScrap]: defineAsyncComponent(
    () => import('./widgetHelp/LaserOutputScrapHelp.vue'),
  ),
  [WidgetEnum.LaserOee]: defineAsyncComponent(
    () => import('./widgetHelp/LaserOeeHelp.vue'),
  ),
  [WidgetEnum.LaserCuttingTime]: defineAsyncComponent(
    () => import('./widgetHelp/LaserCuttingTimeHelp.vue'),
  ),
  [WidgetEnum.LaserOeeHist]: defineAsyncComponent(
    () => import('./widgetHelp/LaserOeeHistHelp.vue'),
  ),
  [WidgetEnum.LaserCuttingTimeHist]: defineAsyncComponent(
    () => import('./widgetHelp/LaserCuttingTimeHistHelp.vue'),
  ),
  [WidgetEnum.LaserStarveBlockHist]: defineAsyncComponent(
    () => import('./widgetHelp/LaserStarveBlockHistHelp.vue'),
  ),
  [WidgetEnum.LaserOutputAndScrapTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/LaserOutputAndScrapTimelineHelp.vue'),
  ),
  [WidgetEnum.CutStatus]: defineAsyncComponent(
    () => import('./widgetHelp/CutStatusHelp.vue'),
  ),
  [WidgetEnum.LaserIntradayAvailabilityTable]: defineAsyncComponent(
    () => import('./widgetHelp/LaserStatesGanttTableHelp.vue'),
  ),
  [WidgetEnum.LaserCurrentWorkload]: defineAsyncComponent(
    () => import('./widgetHelp/LaserCurrentWorkloadHelp.vue'),
  ),

  // Care
  [WidgetEnum.CareOverviewHealthIndicators]: defineAsyncComponent(
    () => import('./widgetHelp/CareOverviewHealthIndicatorsHelp.vue'),
  ),
  [WidgetEnum.CareOverviewModuleEventsIndicators]: defineAsyncComponent(
    () => import('./widgetHelp/CareOverviewModuleEventsIndicatorsHelp.vue'),
  ),
  [WidgetEnum.CareHealthTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/CareHealthTimelineHelp.vue'),
  ),
  [WidgetEnum.CareHealthIndicators]: defineAsyncComponent(
    () => import('./widgetHelp/CareHealthIndicatorsHelp.vue'),
  ),
  [WidgetEnum.CareLaserConsumptionTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/CareLaserConsumptionTimelineHelp.vue'),
  ),
  [WidgetEnum.CareLaserConsumptionPowerUtilizationTimeline]:
    defineAsyncComponent(
      () =>
        import(
          './widgetHelp/CareLaserConsumptionPowerUtilizationTimelineHelp.vue'
        ),
    ),
  [WidgetEnum.CareLaserConsumptionAvailableVsUsedTimeline]:
    defineAsyncComponent(
      () =>
        import(
          './widgetHelp/CareLaserConsumptionAvailableVsUsedTimelineHelp.vue'
        ),
    ),
  [WidgetEnum.CareEventsTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/CareEventsTimelineHelp.vue'),
  ),
  [WidgetEnum.CareCuttingHeadDiodesAndDrawerCyclesTimeline]:
    defineAsyncComponent(
      () =>
        import(
          './widgetHelp/CareCuttingHeadDiodesAndDrawerCyclesTimelineHelp.vue'
        ),
    ),
  [WidgetEnum.CareCuttingHeadEventsTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/CareCuttingHeadEventsTimelineHelp.vue'),
  ),
  [WidgetEnum.CareEventsByModule]: defineAsyncComponent(
    () => import('./widgetHelp/CareEventsByModuleHelp.vue'),
  ),
  [WidgetEnum.CareAlertOccurrencesTable]: defineAsyncComponent(
    () => import('./widgetHelp/CareAlertOccurrencesTableHelp.vue'),
  ),
  [WidgetEnum.CareCuttingHeadTemperatures]: defineAsyncComponent(
    () => import('./widgetHelp/CareCuttingHeadTemperaturesHelp.vue'),
  ),
  [WidgetEnum.EventsTableExpandedView]: defineAsyncComponent(
    () => import('./widgetHelp/EventsTableExpandedViewHelp.vue'),
  ),

  // Technology
  [WidgetEnum.TechnologyOverviewCuttingHoursTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyOverviewCuttingHoursTimelineHelp.vue'),
  ),
  [WidgetEnum.TechnologyOverviewLaserConsumptionTimeline]: defineAsyncComponent(
    () =>
      import('./widgetHelp/TechnologyOverviewLaserConsumptionTimelineHelp.vue'),
  ),
  [WidgetEnum.TechnologyOverviewSscFigures]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyOverviewSscFiguresHelp.vue'),
  ),
  [WidgetEnum.TechnologyTemperatures]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyTemperaturesHelp.vue'),
  ),
  [WidgetEnum.TechnologyDriveCurrentTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyDriveCurrentTimelineHelp.vue'),
  ),
  [WidgetEnum.TechnologyDriveCurrentDifferenceHistogram]: defineAsyncComponent(
    () =>
      import('./widgetHelp/TechnologyDriveCurrentDifferenceHistogramHelp.vue'),
  ),
  [WidgetEnum.TechnologyDriveAccumulatedCurrentDifferenceTimeline]:
    defineAsyncComponent(
      () =>
        import(
          './widgetHelp/TechnologyDriveAccumulatedCurrentDifferenceTimelineHelp.vue'
        ),
    ),
  [WidgetEnum.TechnologyDrawerInformationTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyDrawerInformationTimelineHelp.vue'),
  ),
  [WidgetEnum.TechnologyDrawerCycleTimes]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyDrawerCycleTimesHelp.vue'),
  ),
  [WidgetEnum.TechnologyOverviewDrawerCycleTimes]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyDrawerCycleTimesHelp.vue'), // Both use the same help widget
  ),
  [WidgetEnum.TechnologyLaserConsumptionTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyLaserConsumptionTimelineHelp.vue'),
  ),
  [WidgetEnum.TechnologyLaserUsedVsNotUsedTimes]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyLaserUsedVsNotUsedTimesHelp.vue'),
  ),
  [WidgetEnum.TechnologyLaserPowerUtilizationTimes]: defineAsyncComponent(
    () => import('./widgetHelp/TechnologyLaserPowerUtilizationTimesHelp.vue'),
  ),

  // Bend
  [WidgetEnum.BendingAvailability]: defineAsyncComponent(
    () => import('./widgetHelp/BendingAvailabilityHelp.vue'),
  ),
  [WidgetEnum.BendingTimeBetweenBend]: defineAsyncComponent(
    () => import('./widgetHelp/BendingTimeBetweenBendHelp.vue'),
  ),
  [WidgetEnum.BendingTopParts]: defineAsyncComponent(
    () => import('./widgetHelp/BendingTopPartsHelp.vue'),
  ),
  [WidgetEnum.BendingPerformancePart]: defineAsyncComponent(
    () => import('./widgetHelp/BendingPerformancePartHelp.vue'),
  ),
  [WidgetEnum.BendingAvailabilityHist]: defineAsyncComponent(
    () => import('./widgetHelp/BendingAvailabilityHistHelp.vue'),
  ),
  [WidgetEnum.BendingTimeBetweenBendHist]: defineAsyncComponent(
    () => import('./widgetHelp/BendingTimeBetweenBendHistHelp.vue'),
  ),
  [WidgetEnum.BendingPerformancePartHist]: defineAsyncComponent(
    () => import('./widgetHelp/BendingPerformancePartHistHelp.vue'),
  ),
  [WidgetEnum.BendingPerformanceHist]: defineAsyncComponent(
    () => import('./widgetHelp/BendingPerformanceHistHelp.vue'),
  ),
  [WidgetEnum.BendingPerformance]: defineAsyncComponent(
    () => import('./widgetHelp/BendingPerformanceHelp.vue'),
  ),
  [WidgetEnum.BendStatus]: defineAsyncComponent(
    () => import('./widgetHelp/BendStatusHelp.vue'),
  ),
  [WidgetEnum.BendingNumberOfBendsTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/BendingNumberOfBendsTimelineHelp.vue'),
  ),
  [WidgetEnum.BendIntradayAvailabilityTable]: defineAsyncComponent(
    () => import('./widgetHelp/BendIntradayAvailabilityTableHelp.vue'),
  ),
  [WidgetEnum.BendProductionHistory]: defineAsyncComponent(
    () => import('./widgetHelp/BendProductionHistoryHelp.vue'),
  ),

  // Tube
  [WidgetEnum.TubeAvailability]: defineAsyncComponent(
    () => import('./widgetHelp/TubeAvailabilityHelp.vue'),
  ),
  [WidgetEnum.TubeAvailabilityHist]: defineAsyncComponent(
    () => import('./widgetHelp/LaserAvailabilityHistHelp.vue'), // Both use the same help widget
  ),
  [WidgetEnum.TubeStarveBlock]: defineAsyncComponent(
    () => import('./widgetHelp/TubeStarveBlockHelp.vue'),
  ),
  [WidgetEnum.TubeOutputScrap]: defineAsyncComponent(
    () => import('./widgetHelp/TubeOutputScrapHelp.vue'),
  ),
  [WidgetEnum.TubeOee]: defineAsyncComponent(
    () => import('./widgetHelp/TubeOeeHelp.vue'),
  ),
  [WidgetEnum.TubeCuttingTime]: defineAsyncComponent(
    () => import('./widgetHelp/TubeCuttingTimeHelp.vue'),
  ),
  [WidgetEnum.TubeOeeHist]: defineAsyncComponent(
    () => import('./widgetHelp/TubeOeeHistHelp.vue'),
  ),
  [WidgetEnum.TubeCuttingTimeHist]: defineAsyncComponent(
    () => import('./widgetHelp/TubeCuttingTimeHistHelp.vue'),
  ),
  [WidgetEnum.TubeStarveBlockHist]: defineAsyncComponent(
    () => import('./widgetHelp/TubeStarveBlockHistHelp.vue'),
  ),
  [WidgetEnum.TubeOutputScrapHist]: defineAsyncComponent(
    () => import('./widgetHelp/TubeOutputScrapHistHelp.vue'),
  ),
  [WidgetEnum.TubeStatus]: defineAsyncComponent(
    () => import('./widgetHelp/TubeStatusHelp.vue'),
  ),
  [WidgetEnum.TubeProductivity]: defineAsyncComponent(
    () => import('./widgetHelp/LaserProductivityHelp.vue'), // Both use the same help widget
  ),
  [WidgetEnum.TubeProductivityHist]: defineAsyncComponent(
    () => import('./widgetHelp/LaserProductivityHistHelp.vue'), // Both use the same help widget
  ),
  [WidgetEnum.TubeIntradayAvailabilityTable]: defineAsyncComponent(
    () => import('./widgetHelp/LaserStatesGanttTableHelp.vue'), // Both use the same help widget
  ),

  // Generic
  [WidgetEnum.CameraView]: defineAsyncComponent(
    () => import('./widgetHelp/CameraViewHelp.vue'),
  ),
  [WidgetEnum.FactoryOverview]: defineAsyncComponent(
    () => import('./widgetHelp/FactoryOverviewHelp.vue'),
  ),

  /* BC */
  //  Overview
  [WidgetEnum.SalesMap]: defineAsyncComponent(
    () => import('./widgetHelp/SalesMapHelp.vue'),
  ),
  [WidgetEnum.QuotesMap]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesMapHelp.vue'),
  ),
  [WidgetEnum.OpenSalesFunnel]: defineAsyncComponent(
    () => import('./widgetHelp/OpenSalesFunnelHelp.vue'),
  ),
  [WidgetEnum.BusinessOverviewFigures]: defineAsyncComponent(
    () => import('./widgetHelp/BusinessOverviewFiguresHelp.vue'),
  ),

  // Quotes
  [WidgetEnum.QuotesConversionRates]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesConversionRatesHelp.vue'),
  ),
  [WidgetEnum.QuotesConversionRatesGauge]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesConversionRatesGaugeHelp.vue'),
  ),
  [WidgetEnum.QuotesAbcCustomers]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesAbcCustomersHelp.vue'),
  ),
  [WidgetEnum.QuotesFigures]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesFiguresHelp.vue'),
  ),
  [WidgetEnum.QuotesFiguresDetailed]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesFiguresDetailedHelp.vue'),
  ),
  [WidgetEnum.QuotesCustomerEvolution]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesCustomerEvolutionHelp.vue'),
  ),
  [WidgetEnum.QuotesTopQuotedMaterialsTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesTopQuotedMaterialsTimelineHelp.vue'),
  ),
  [WidgetEnum.QuotesQuotedMaterialsList]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesQuotedMaterialsListHelp.vue'),
  ),
  [WidgetEnum.QuotesConvertedAmountTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesConvertedAmountTimelineHelp.vue'),
  ),
  [WidgetEnum.QuotesSize]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesSizeHelp.vue'),
  ),
  [WidgetEnum.QuotesConvertedMap]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesConvertedMapHelp.vue'),
  ),
  [WidgetEnum.QuotesTopSalespeopleDetailed]: defineAsyncComponent(
    () => import('./widgetHelp/QuotesTopSalespeopleDetailedHelp.vue'),
  ),

  // Sales
  [WidgetEnum.SalesFunnel]: defineAsyncComponent(
    () => import('./widgetHelp/SalesFunnelHelp.vue'),
  ),
  [WidgetEnum.SalesCustomerGroups]: defineAsyncComponent(
    () => import('./widgetHelp/SalesCustomerGroupsHelp.vue'),
  ),
  [WidgetEnum.SalesFigures]: defineAsyncComponent(
    () => import('./widgetHelp/SalesFiguresHelp.vue'),
  ),
  [WidgetEnum.SalesTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/SalesTimelineHelp.vue'),
  ),
  [WidgetEnum.SalesTopSalespeople]: defineAsyncComponent(
    () => import('./widgetHelp/SalesTopSalespeopleHelp.vue'),
  ),
  [WidgetEnum.AmountVsNumberOfQuotesBySalesperson]: defineAsyncComponent(
    () =>
      import('./widgetHelp/SalesAmountVsNumberOfQuotesBySalespersonHelp.vue'),
  ),
  [WidgetEnum.SalesAmountBySalesperson]: defineAsyncComponent(
    () => import('./widgetHelp/SalesAmountBySalespersonHelp.vue'),
  ),
  [WidgetEnum.SalesItemChangesBySalesperson]: defineAsyncComponent(
    () => import('./widgetHelp/SalesItemChangesBySalespersonHelp.vue'),
  ),
  [WidgetEnum.NumberOfSalesBySalesperson]: defineAsyncComponent(
    () => import('./widgetHelp/NumberOfSalesBySalespersonHelp.vue'),
  ),
  [WidgetEnum.SalesPerSalespersonTimeline]: defineAsyncComponent(
    () => import('./widgetHelp/SalesPerSalespersonTimelineHelp.vue'),
  ),
  [WidgetEnum.SalesUnpaidDistribution]: defineAsyncComponent(
    () => import('./widgetHelp/SalesUnpaidDistributionHelp.vue'),
  ),

  /* SFC */
  // Manufacturing
  [WidgetEnum.ManufacturingReleasedPOStatus]: defineAsyncComponent(
    () => import('./widgetHelp/ManufacturingReleasedPOStatusHelp.vue'),
  ),
  [WidgetEnum.ManufacturingPOStatus]: defineAsyncComponent(
    () => import('./widgetHelp/ManufacturingPOStatusHelp.vue'),
  ),
  [WidgetEnum.ManufacturingPOLStatusDueDate]: defineAsyncComponent(
    () => import('./widgetHelp/ManufacturingPOLStatusDueDateHelp.vue'),
  ),
  [WidgetEnum.ManufacturingPOFinishedDueDate]: defineAsyncComponent(
    () => import('./widgetHelp/ManufacturingPOFinishedDueDateHelp.vue'),
  ),
  [WidgetEnum.ManufacturingFinishedPOEstimatedVsActualPOL]:
    defineAsyncComponent(
      () =>
        import(
          './widgetHelp/ManufacturingFinishedPOEstimatedVsActualPOLHelp.vue'
        ),
    ),
  [WidgetEnum.ManufacturingFigures]: defineAsyncComponent(
    () => import('./widgetHelp/ManufacturingFiguresHelp.vue'),
  ),
  /**
   * The following widgets do not have a corresponding widget help.
   * Still, the compiler requires us to add all WidgetEnums to this record, so all of them are set to undefined
   */
  [WidgetEnum.CareOverviewDevice]: undefined,
  [WidgetEnum.EventsTable]: undefined,
  [WidgetEnum.CareErrorsAndWarningsBarChart]: undefined,
  [WidgetEnum.BendSheetPartsGanttTable]: undefined,
  [WidgetEnum.BendProductivityFigures]: undefined,
  [WidgetEnum.BendShiftStatistics]: undefined,
  [WidgetEnum.BendRankingOfParts]: undefined,
  [WidgetEnum.BendFlowSpeedStatesGanttTable]: undefined,
  [WidgetEnum.BendStatusOverview]: undefined,
  [WidgetEnum.OverviewData]: undefined,
  [WidgetEnum.QuotesSizeFilter]: undefined,
  [WidgetEnum.Dummy]: undefined,
  [WidgetEnum.NumberOfBendsWidget]: undefined,
  [WidgetEnum.PeakHourlyBendingWidget]: undefined,
  [WidgetEnum.BendProductionOutputWidget]: undefined,
};

return { __sfc: true,openCloseAll, onDropdownTriggerClicked, componentHelp }
}

})